import React from 'react';
import { Smile, Zap, Eye, Moon } from 'lucide-react';
import { GlassCard } from './DashboardShared';

const CheckinForm = ({ showCheckin, setShowCheckin, checkinData, setCheckinData, submitCheckin }) => {
  if (!showCheckin) {
    return (
      <button onClick={() => setShowCheckin(true)}
        className="w-full py-2.5 rounded text-[11px] font-medium flex items-center justify-center gap-1.5 transition-all duration-200 hover:scale-[1.01]"
        style={{
          background: 'rgba(56,189,248,0.04)', border: '1px solid rgba(56,189,248,0.1)',
          color: '#94A3B8',
        }}
        data-testid="action-checkin-button">
        <Smile className="w-3.5 h-3.5" style={{ color: '#38BDF8' }} /> Check-in Yap
      </button>
    );
  }

  return (
    <GlassCard data-testid="checkin-form" style={{ padding: '16px', border: '1px solid rgba(34,211,238,0.15)' }}>
      <div className="flex items-center gap-2 mb-3">
        <Smile className="w-4 h-4 text-cyan-400" />
        <h3 className="text-white font-bold text-xs">Günlük Check-in</h3>
      </div>
      <div className="space-y-3 mb-3">
        {[
          { icon: Smile, label: 'Ruh Hali', field: 'mood', color: '#A78BFA' },
          { icon: Zap, label: 'Enerji', field: 'energy', color: '#FBBF24' },
          { icon: Eye, label: 'Odak', field: 'focus', color: '#34D399' },
        ].map(s => (
          <div key={s.field}>
            <label className="flex items-center gap-1.5 text-[10px] text-white/50 mb-1">
              <s.icon className="w-3 h-3" style={{ color: s.color }} /> {s.label} ({checkinData[s.field]})
            </label>
            <input type="range" min="1" max="10" value={checkinData[s.field]}
              onChange={(e) => setCheckinData({...checkinData, [s.field]: parseInt(e.target.value)})}
              className="w-full" style={{ accentColor: s.color }} data-testid={`checkin-${s.field}-slider`} />
          </div>
        ))}
        <div>
          <label className="flex items-center gap-1.5 text-[10px] text-white/50 mb-1"><Moon className="w-3 h-3 text-cyan-400" /> Uyku (saat)</label>
          <input type="number" step="0.5" min="0" max="24" value={checkinData.sleep_hours}
            onChange={(e) => setCheckinData({...checkinData, sleep_hours: parseFloat(e.target.value)})}
            className="w-full bg-white/10 border border-white/10 rounded px-3 py-1.5 text-white text-xs outline-none focus:border-cyan-400/50"
            data-testid="checkin-sleep-input" />
        </div>
      </div>
      <div className="flex gap-2">
        <button onClick={submitCheckin} className="text-white rounded px-4 py-1.5 text-xs font-semibold" style={{
          background: 'linear-gradient(135deg, #3B82F6, #22D3EE)',
        }} data-testid="save-checkin-button">Kaydet</button>
        <button onClick={() => setShowCheckin(false)} className="text-white/30 hover:text-white/50 text-xs" data-testid="cancel-checkin-button">Iptal</button>
      </div>
    </GlassCard>
  );
};

export default CheckinForm;
